// extracted by mini-css-extract-plugin
module.exports = {"proteinBack":"FirstViewSection_proteinBack__IdeEI","proteinBackLogo":"FirstViewSection_proteinBackLogo__mmyM9"};